import { apiClient } from '@/lib/api-client';
import type { CurrentTenant } from '../types';

export interface PaymentLinkUrls {
    starterMonthly: string;
    starterAnnual: string;
    proMonthly: string;
    proAnnual: string;
    businessMonthly: string;
    businessAnnual: string;
}

export const subscriptionApi = {
    /**
     * Fetches the current tenant's subscription state — tier, status, current-month
     * metered quota usage, and seat limits. Used by every page via the
     * useCurrentTenant() hook to decide what to gate, what to meter, and where
     * to show "Upgrade" CTAs.
     */
    me: (): Promise<CurrentTenant> =>
        apiClient.get('/tenants/me').then((r) => r.data.data),

    /**
     * Tier-and-cycle Stripe Payment Link URLs configured on the backend. The
     * SPA appends `?client_reference_id=${tenantId}&prefilled_email=${email}`
     * before redirecting so Stripe surfaces the tenant link back via webhook.
     */
    paymentLinks: (): Promise<PaymentLinkUrls> =>
        apiClient.get('/billing/payment-links').then((r) => r.data.data),
};
